module.exports = __webpack_public_path__ + "33d7375b.svg";